import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import {Subscription, SubscriptionPeriod} from "models"
import ApiMakerTable from "shared/api-maker-table"
import classNames from "classnames"
import ContactLink from "components/contacts/link"
import linkProps from "shared/link-props"
import memo from "set-state-compare/build/memo"
import PlanLink from "components/plans/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import SubscriptionLink from "components/subscriptions/link"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

export default memo(shapeComponent(class ComponentsSubscriptionPeriodsTable extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    userLayout: PropTypes.bool.isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.subscription_periods.table"})

    this.t = t
  }

  render() {
    const {columns, editModelPath, viewModelPath} = this.tt
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--subscription-periods--table", className)}
        columns={columns}
        defaultParams={{s: "starts_at desc"}}
        editModelPath={editModelPath}
        modelClass={SubscriptionPeriod}
        preloads={["subscription.contact", "subscription.plan"]}
        select={{
          Contact: ["firstName", "id", "lastName", "name"],
          Plan: ["id", "name"],
          Subscription: ["id"],
          SubscriptionPeriod: ["id"]
        }}
        viewModelPath={viewModelPath}
        {...restProps}
      />
    )
  }

  columns = () => [
    {
      attribute: "id",
      content: this.tt.subscriptionContent,
      label: SubscriptionPeriod.humanAttributeName("subscription"),
      path: ["subscription"],
      sortKey: "subscriptionId"
    },
    {
      content: this.tt.contactContent,
      identifier: "contact",
      label: Subscription.humanAttributeName("contact")
    },
    {
      attribute: "name",
      content: this.tt.planContent,
      label: Subscription.humanAttributeName("plan"),
      path: ["subscription", "plan"],
      sortKey: "subscriptionPlanCurrentTranslationName"
    },
    {
      attribute: "startsAt",
      sortKey: "startsAt"
    },
    {
      attribute: "endsAt",
      sortKey: "endsAt"
    },
    {
      attribute: "createdAt",
      defaultVisible: false,
      sortKey: "createdAt"
    },
    {
      attribute: "updatedAt",
      defaultVisible: false,
      sortKey: "updatedAt"
    }
  ]

  editModelPath = ({subscriptionPeriod}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.editAdminSubscriptionPeriodPath(subscriptionPeriod.id())
  }

  viewModelPath = ({subscriptionPeriod}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.adminSubscriptionPeriodPath(subscriptionPeriod.id())
  }

  planContent = ({subscriptionPeriod}) => subscriptionPeriod.subscription()?.plan() &&
    <PlanLink plan={subscriptionPeriod.subscription().plan()} {...linkProps(this.props)} />

  contactContent = ({subscriptionPeriod}) => subscriptionPeriod.subscription()?.contact() &&
    <ContactLink contact={subscriptionPeriod.subscription().contact()} {...linkProps(this.props)} />

  subscriptionContent = ({subscriptionPeriod}) => subscriptionPeriod.subscription() &&
    <SubscriptionLink children={subscriptionPeriod.subscription().id()} subscription={subscriptionPeriod.subscription()} {...linkProps(this.props)} />
}))
